var $J7s8E$react = require("react");
var $J7s8E$styledcomponents = require("styled-components");
var $J7s8E$muimaterialGrid = require("@mui/material/Grid");
var $J7s8E$reactjsxruntime = require("react/jsx-runtime");

"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "Grid", {
    enumerable: true,
    get: function get() {
        return $cc328f81773e9021$exports.Grid;
    }
});
var $cc328f81773e9021$exports = {};
"use strict";
function $cc328f81773e9021$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $cc328f81773e9021$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $cc328f81773e9021$var$_typeof(o);
}
Object.defineProperty($cc328f81773e9021$exports, "__esModule", {
    value: true
});
$cc328f81773e9021$exports.Grid = void 0;

var $cc328f81773e9021$var$_react = $cc328f81773e9021$var$_interopRequireDefault($J7s8E$react);

var $cc328f81773e9021$var$_styledComponents = $cc328f81773e9021$var$_interopRequireDefault($J7s8E$styledcomponents);

var $cc328f81773e9021$var$_Grid = $cc328f81773e9021$var$_interopRequireDefault($J7s8E$muimaterialGrid);

var $cc328f81773e9021$var$_excluded = [
    "inline",
    "spacing",
    "spacingTop",
    "spacingLeft",
    "spacingRight",
    "spacingBottom",
    "xsSpacing",
    "xsSpacingTop",
    "xsSpacingLeft",
    "xsSpacingRight",
    "xsSpacingBottom",
    "mdSpacing",
    "mdSpacingTop",
    "mdSpacingLeft",
    "mdSpacingRight",
    "mdSpacingBottom",
    "mdUpSpacing",
    "mdUpSpacingTop",
    "mdUpSpacingLeft",
    "mdUpSpacingRight",
    "mdUpSpacingBottom",
    "mdDownSpacing",
    "mdDownSpacingTop",
    "mdDownSpacingLeft",
    "mdDownSpacingRight",
    "mdDownSpacingBottom",
    "lgSpacing",
    "lgSpacingTop",
    "lgSpacingLeft",
    "lgSpacingRight",
    "lgSpacingBottom",
    "xsDirection",
    "mdDirection",
    "mdUpDirection",
    "mdDownDirection",
    "lgDirection",
    "xsAlignItems",
    "mdAlignItems",
    "mdUpAlignItems",
    "mdDownAlignItems",
    "lgAlignItems",
    "xsJustify",
    "mdJustify",
    "mdUpJustify",
    "mdDownJustify",
    "lgJustify",
    "fullWidth"
];
var $cc328f81773e9021$var$_templateObject;
function $cc328f81773e9021$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
function $cc328f81773e9021$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $cc328f81773e9021$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $cc328f81773e9021$var$ownKeys(Object(t), !0).forEach(function(r) {
            $cc328f81773e9021$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $cc328f81773e9021$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $cc328f81773e9021$var$_defineProperty(e, r, t) {
    return (r = $cc328f81773e9021$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $cc328f81773e9021$var$_toPropertyKey(t) {
    var i = $cc328f81773e9021$var$_toPrimitive(t, "string");
    return "symbol" == $cc328f81773e9021$var$_typeof(i) ? i : i + "";
}
function $cc328f81773e9021$var$_toPrimitive(t, r) {
    if ("object" != $cc328f81773e9021$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $cc328f81773e9021$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $cc328f81773e9021$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $cc328f81773e9021$var$_objectWithoutPropertiesLoose(e, t);
    if (Object.getOwnPropertySymbols) {
        var s = Object.getOwnPropertySymbols(e);
        for(r = 0; r < s.length; r++)o = s[r], t.includes(o) || ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
function $cc328f81773e9021$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.includes(n)) continue;
        t[n] = r[n];
    }
    return t;
}
function $cc328f81773e9021$var$_taggedTemplateLiteral(e, t) {
    return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, {
        raw: {
            value: Object.freeze(t)
        }
    }));
}
var $cc328f81773e9021$var$SPACE_MULTIPLIER = 5;
var $cc328f81773e9021$var$spaceInPixels = function spaceInPixels(space) {
    return "".concat((space === true ? 1 : Number(space)) * $cc328f81773e9021$var$SPACE_MULTIPLIER, "px");
};
/**
 * check https://material-ui.com/api/grid/ for Grid props
 * - xs is for xs and higher
 * - md is for md and higher
 * - lg is for lg and higher
 *
 * we have added the following props where we use 3 variants for each breakpoint (md, mdUp, mdDown)
 * - spacing is for all viewports (this is supported by Grid, but we are overriding the default behavior)
 * - xsSpacing is for only xs (mobile)
 * - mdSpacing is for only md (tablet)
 * - mdUpSpacing is for md and higher (tablet and higher)
 * - mdDownSpacing is for md and lower (tablet and lower)
 * - lgSpacing is for only lg (desktop)
 * - the same rules apply for the direction props
 *
 * currently, we don't use sm and xl
 */ var $cc328f81773e9021$var$StyledGrid = $cc328f81773e9021$exports.Grid = (0, $cc328f81773e9021$var$_styledComponents["default"])(function(_ref) {
    var inline = _ref.inline, spacing = _ref.spacing, spacingTop = _ref.spacingTop, spacingLeft = _ref.spacingLeft, spacingRight = _ref.spacingRight, spacingBottom = _ref.spacingBottom, xsSpacing = _ref.xsSpacing, xsSpacingTop = _ref.xsSpacingTop, xsSpacingLeft = _ref.xsSpacingLeft, xsSpacingRight = _ref.xsSpacingRight, xsSpacingBottom = _ref.xsSpacingBottom, mdSpacing = _ref.mdSpacing, mdSpacingTop = _ref.mdSpacingTop, mdSpacingLeft = _ref.mdSpacingLeft, mdSpacingRight = _ref.mdSpacingRight, mdSpacingBottom = _ref.mdSpacingBottom, mdUpSpacing = _ref.mdUpSpacing, mdUpSpacingTop = _ref.mdUpSpacingTop, mdUpSpacingLeft = _ref.mdUpSpacingLeft, mdUpSpacingRight = _ref.mdUpSpacingRight, mdUpSpacingBottom = _ref.mdUpSpacingBottom, mdDownSpacing = _ref.mdDownSpacing, mdDownSpacingTop = _ref.mdDownSpacingTop, mdDownSpacingLeft = _ref.mdDownSpacingLeft, mdDownSpacingRight = _ref.mdDownSpacingRight, mdDownSpacingBottom = _ref.mdDownSpacingBottom, lgSpacing = _ref.lgSpacing, lgSpacingTop = _ref.lgSpacingTop, lgSpacingLeft = _ref.lgSpacingLeft, lgSpacingRight = _ref.lgSpacingRight, lgSpacingBottom = _ref.lgSpacingBottom, xsDirection = _ref.xsDirection, mdDirection = _ref.mdDirection, mdUpDirection = _ref.mdUpDirection, mdDownDirection = _ref.mdDownDirection, lgDirection = _ref.lgDirection, xsAlignItems = _ref.xsAlignItems, mdAlignItems = _ref.mdAlignItems, mdUpAlignItems = _ref.mdUpAlignItems, mdDownAlignItems = _ref.mdDownAlignItems, lgAlignItems = _ref.lgAlignItems, xsJustify = _ref.xsJustify, mdJustify = _ref.mdJustify, mdUpJustify = _ref.mdUpJustify, mdDownJustify = _ref.mdDownJustify, lgJustify = _ref.lgJustify, fullWidth = _ref.fullWidth, rest = $cc328f81773e9021$var$_objectWithoutProperties(_ref, $cc328f81773e9021$var$_excluded);
    return /*#__PURE__*/ (0, $J7s8E$reactjsxruntime.jsx)($cc328f81773e9021$var$_Grid["default"], $cc328f81773e9021$var$_objectSpread({}, rest));
}).attrs(function() {
    return {
        classes: {
            item: "item",
            container: "container"
        }
    };
})($cc328f81773e9021$var$_templateObject || ($cc328f81773e9021$var$_templateObject = $cc328f81773e9021$var$_taggedTemplateLiteral([
    "\n  ",
    "\n\n  &.container {\n    ",
    "\n    ",
    "\n    ",
    "\n    ",
    "\n    ",
    "\n\n    @media ",
    " {\n      ",
    "\n      ",
    "\n      ",
    "\n      ",
    "\n\n      ",
    "\n      ",
    "\n      ",
    "\n      ",
    "\n    }\n\n    @media ",
    " {\n      ",
    "\n      ",
    "\n      ",
    "\n      ",
    "\n\n      ",
    "\n      ",
    "\n      ",
    "\n      ",
    "\n    }\n\n    @media ",
    " {\n      ",
    "\n      ",
    "\n      ",
    "\n      ",
    "\n\n        ",
    "\n        ",
    "\n        ",
    "\n        ",
    "\n    }\n\n    @media ",
    " {\n      ",
    "\n      ",
    "\n      ",
    "\n      ",
    "\n\n      ",
    "\n      ",
    "\n      ",
    "\n      ",
    "\n    }\n\n    @media ",
    " {\n      ",
    "\n      ",
    "\n      ",
    "\n      ",
    "\n\n      ",
    "\n      ",
    "\n      ",
    "\n      ",
    "\n    }\n  }\n\n  &.item {\n    ",
    "\n\n    ",
    "\n    ",
    "\n    ",
    "\n    ",
    "\n    ",
    "\n    \n    @media ",
    " {\n      ",
    "\n      ",
    "\n      ",
    "\n      ",
    "\n    }\n\n    @media ",
    " {\n      ",
    "\n      ",
    "\n      ",
    "\n      ",
    "\n    }\n\n    @media ",
    " {\n      ",
    "\n      ",
    "\n      ",
    "\n      ",
    "\n    }\n\n    @media ",
    " {\n      ",
    "\n      ",
    "\n      ",
    "\n      ",
    "\n    }\n\n    @media ",
    " {\n      ",
    "\n      ",
    "\n      ",
    "\n      ",
    "\n    }\n\n    &:empty {\n      padding: 0;\n    }\n  }\n"
])), function(props) {
    return props.fullWidth && "width: 100%;";
}, function(props) {
    return props.spacing && "padding: ".concat($cc328f81773e9021$var$spaceInPixels(props.spacing), ";");
}, function(props) {
    return props.spacingTop && "padding-top: ".concat($cc328f81773e9021$var$spaceInPixels(props.spacingTop), ";");
}, function(props) {
    return props.spacingLeft && "padding-left: ".concat($cc328f81773e9021$var$spaceInPixels(props.spacingLeft), ";");
}, function(props) {
    return props.spacingRight && "padding-right: ".concat($cc328f81773e9021$var$spaceInPixels(props.spacingRight), ";");
}, function(props) {
    return props.spacingBottom && "padding-bottom: ".concat($cc328f81773e9021$var$spaceInPixels(props.spacingBottom), ";");
}, function(props) {
    return props.theme.query.mobile;
}, function(props) {
    return props.xsSpacing && "padding: ".concat($cc328f81773e9021$var$spaceInPixels(props.xsSpacing), ";");
}, function(props) {
    return props.xsDirection && "flex-direction: ".concat(props.xsDirection, ";");
}, function(props) {
    return props.xsAlignItems && "align-items: ".concat(props.xsAlignItems, ";");
}, function(props) {
    return props.xsJustify && "justify-content: ".concat(props.xsJustify, ";");
}, function(props) {
    return props.xsSpacingTop && "padding-top: ".concat($cc328f81773e9021$var$spaceInPixels(props.xsSpacingTop), ";");
}, function(props) {
    return props.xsSpacingLeft && "padding-left: ".concat($cc328f81773e9021$var$spaceInPixels(props.xsSpacingLeft), ";");
}, function(props) {
    return props.xsSpacingRight && "padding-right: ".concat($cc328f81773e9021$var$spaceInPixels(props.xsSpacingRight), ";");
}, function(props) {
    return props.xsSpacingBottom && "padding-bottom: ".concat($cc328f81773e9021$var$spaceInPixels(props.xsSpacingBottom), ";");
}, function(props) {
    return props.theme.query.tablet;
}, function(props) {
    return props.mdSpacing && "padding: ".concat($cc328f81773e9021$var$spaceInPixels(props.mdSpacing), ";");
}, function(props) {
    return props.mdDirection && "flex-direction: ".concat(props.mdDirection, ";");
}, function(props) {
    return props.mdAlignItems && "align-items: ".concat(props.mdAlignItems, ";");
}, function(props) {
    return props.mdJustify && "justify-content: ".concat(props.mdJustify, ";");
}, function(props) {
    return props.mdSpacingTop && "padding-top: ".concat($cc328f81773e9021$var$spaceInPixels(props.mdSpacingTop), ";");
}, function(props) {
    return props.mdSpacingLeft && "padding-left: ".concat($cc328f81773e9021$var$spaceInPixels(props.mdSpacingLeft), ";");
}, function(props) {
    return props.mdSpacingRight && "padding-right: ".concat($cc328f81773e9021$var$spaceInPixels(props.mdSpacingRight), ";");
}, function(props) {
    return props.mdSpacingBottom && "padding-bottom: ".concat($cc328f81773e9021$var$spaceInPixels(props.mdSpacingBottom), ";");
}, function(props) {
    return props.theme.query.max.lg;
}, function(props) {
    return props.mdDownSpacing && "padding: ".concat($cc328f81773e9021$var$spaceInPixels(props.mdDownSpacing), ";");
}, function(props) {
    return props.mdDownDirection && "flex-direction: ".concat(props.mdDownDirection, ";");
}, function(props) {
    return props.mdDownAlignItems && "align-items: ".concat(props.mdDownAlignItems, ";");
}, function(props) {
    return props.mdDownJustify && "justify-content: ".concat(props.mdDownJustify, ";");
}, function(props) {
    return props.mdDownSpacingTop && "padding-top: ".concat($cc328f81773e9021$var$spaceInPixels(props.mdDownSpacingTop), ";");
}, function(props) {
    return props.mdDownSpacingLeft && "padding-left: ".concat($cc328f81773e9021$var$spaceInPixels(props.mdDownSpacingLeft), ";");
}, function(props) {
    return props.mdDownSpacingRight && "padding-right: ".concat($cc328f81773e9021$var$spaceInPixels(props.mdDownSpacingRight), ";");
}, function(props) {
    return props.mdDownSpacingBottom && "padding-bottom: ".concat($cc328f81773e9021$var$spaceInPixels(props.mdDownSpacingBottom), ";");
}, function(props) {
    return props.theme.query.min.md;
}, function(props) {
    return props.mdUpDirection && "flex-direction: ".concat(props.mdUpDirection, ";");
}, function(props) {
    return props.mdUpSpacing && "padding: ".concat($cc328f81773e9021$var$spaceInPixels(props.mdUpSpacing), ";");
}, function(props) {
    return props.mdUpAlignItems && "align-items: ".concat(props.mdUpAlignItems, ";");
}, function(props) {
    return props.mdUpJustify && "justify-content: ".concat(props.mdUpJustify, ";");
}, function(props) {
    return props.mdUpSpacingTop && "padding-top: ".concat($cc328f81773e9021$var$spaceInPixels(props.mdUpSpacingTop), ";");
}, function(props) {
    return props.mdUpSpacingLeft && "padding-left: ".concat($cc328f81773e9021$var$spaceInPixels(props.mdUpSpacingLeft), ";");
}, function(props) {
    return props.mdUpSpacingRight && "padding-right: ".concat($cc328f81773e9021$var$spaceInPixels(props.mdUpSpacingRight), ";");
}, function(props) {
    return props.mdUpSpacingBottom && "padding-bottom: ".concat($cc328f81773e9021$var$spaceInPixels(props.mdUpSpacingBottom), ";");
}, function(props) {
    return props.theme.query.min.lg;
}, function(props) {
    return props.lgSpacing && "padding: ".concat($cc328f81773e9021$var$spaceInPixels(props.lgSpacing), ";");
}, function(props) {
    return props.lgDirection && "flex-direction: ".concat(props.lgDirection, ";");
}, function(props) {
    return props.lgAlignItems && "align-items: ".concat(props.lgAlignItems, ";");
}, function(props) {
    return props.lgJustify && "justify-content: ".concat(props.lgJustify, ";");
}, function(props) {
    return props.lgSpacingTop && "padding-top: ".concat($cc328f81773e9021$var$spaceInPixels(props.lgSpacingTop), ";");
}, function(props) {
    return props.lgSpacingLeft && "padding-left: ".concat($cc328f81773e9021$var$spaceInPixels(props.lgSpacingLeft), ";");
}, function(props) {
    return props.lgSpacingRight && "padding-right: ".concat($cc328f81773e9021$var$spaceInPixels(props.lgSpacingRight), ";");
}, function(props) {
    return props.lgSpacingBottom && "padding-bottom: ".concat($cc328f81773e9021$var$spaceInPixels(props.lgSpacingBottom), ";");
}, function(props) {
    return props.inline && "display: inline-flex;";
}, function(props) {
    return props.spacing && "padding: ".concat($cc328f81773e9021$var$spaceInPixels(props.spacing), ";");
}, function(props) {
    return props.spacingTop && "padding-top: ".concat($cc328f81773e9021$var$spaceInPixels(props.spacingTop), ";");
}, function(props) {
    return props.spacingLeft && "padding-left: ".concat($cc328f81773e9021$var$spaceInPixels(props.spacingLeft), ";");
}, function(props) {
    return props.spacingRight && "padding-right: ".concat($cc328f81773e9021$var$spaceInPixels(props.spacingRight), ";");
}, function(props) {
    return props.spacingBottom && "padding-bottom: ".concat($cc328f81773e9021$var$spaceInPixels(props.spacingBottom), ";");
}, function(props) {
    return props.theme.query.mobile;
}, function(props) {
    return props.xsSpacingTop && "padding-top: ".concat($cc328f81773e9021$var$spaceInPixels(props.xsSpacingTop), ";");
}, function(props) {
    return props.xsSpacingLeft && "padding-left: ".concat($cc328f81773e9021$var$spaceInPixels(props.xsSpacingLeft), ";");
}, function(props) {
    return props.xsSpacingRight && "padding-right: ".concat($cc328f81773e9021$var$spaceInPixels(props.xsSpacingRight), ";");
}, function(props) {
    return props.xsSpacingBottom && "padding-bottom: ".concat($cc328f81773e9021$var$spaceInPixels(props.xsSpacingBottom), ";");
}, function(props) {
    return props.theme.query.tablet;
}, function(props) {
    return props.mdSpacingTop && "padding-top: ".concat($cc328f81773e9021$var$spaceInPixels(props.mdSpacingTop), ";");
}, function(props) {
    return props.mdSpacingLeft && "padding-left: ".concat($cc328f81773e9021$var$spaceInPixels(props.mdSpacingLeft), ";");
}, function(props) {
    return props.mdSpacingRight && "padding-right: ".concat($cc328f81773e9021$var$spaceInPixels(props.mdSpacingRight), ";");
}, function(props) {
    return props.mdSpacingBottom && "padding-bottom: ".concat($cc328f81773e9021$var$spaceInPixels(props.mdSpacingBottom), ";");
}, function(props) {
    return props.theme.query.max.lg;
}, function(props) {
    return props.mdDownSpacingTop && "padding-top: ".concat($cc328f81773e9021$var$spaceInPixels(props.mdDownSpacingTop), ";");
}, function(props) {
    return props.mdDownSpacingLeft && "padding-left: ".concat($cc328f81773e9021$var$spaceInPixels(props.mdDownSpacingLeft), ";");
}, function(props) {
    return props.mdDownSpacingRight && "padding-right: ".concat($cc328f81773e9021$var$spaceInPixels(props.mdDownSpacingRight), ";");
}, function(props) {
    return props.mdDownSpacingBottom && "padding-bottom: ".concat($cc328f81773e9021$var$spaceInPixels(props.mdDownSpacingBottom), ";");
}, function(props) {
    return props.theme.query.min.md;
}, function(props) {
    return props.mdUpSpacingTop && "padding-top: ".concat($cc328f81773e9021$var$spaceInPixels(props.mdUpSpacingTop), ";");
}, function(props) {
    return props.mdUpSpacingLeft && "padding-left: ".concat($cc328f81773e9021$var$spaceInPixels(props.mdUpSpacingLeft), ";");
}, function(props) {
    return props.mdUpSpacingRight && "padding-right: ".concat($cc328f81773e9021$var$spaceInPixels(props.mdUpSpacingRight), ";");
}, function(props) {
    return props.mdUpSpacingBottom && "padding-bottom: ".concat($cc328f81773e9021$var$spaceInPixels(props.mdUpSpacingBottom), ";");
}, function(props) {
    return props.theme.query.min.lg;
}, function(props) {
    return props.lgSpacingTop && "padding-top: ".concat($cc328f81773e9021$var$spaceInPixels(props.lgSpacingTop), ";");
}, function(props) {
    return props.lgSpacingLeft && "padding-left: ".concat($cc328f81773e9021$var$spaceInPixels(props.lgSpacingLeft), ";");
}, function(props) {
    return props.lgSpacingRight && "padding-right: ".concat($cc328f81773e9021$var$spaceInPixels(props.lgSpacingRight), ";");
}, function(props) {
    return props.lgSpacingBottom && "padding-bottom: ".concat($cc328f81773e9021$var$spaceInPixels(props.lgSpacingBottom), ";");
});




//# sourceMappingURL=index.js.map
